import { render, staticRenderFns } from "./IndividualCancellation.vue?vue&type=template&id=79e0ae50&"
import script from "./IndividualCancellation.vue?vue&type=script&lang=js&"
export * from "./IndividualCancellation.vue?vue&type=script&lang=js&"
import style0 from "./IndividualCancellation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports